import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import './InfoTooltip.scss';

const InfoTooltip = ({ text, label }) => {
  const iconRef = useRef();

  useEffect(() => {
    const popover = bootstrap.Popover.getOrCreateInstance(iconRef.current);
    popover.enable();
    return () => popover.dispose();
  }, [text]);

  return (
    <button
      type="button"
      className="InfoTooltip"
      ref={iconRef}
      aria-label={label}
      data-bs-toggle="popover"
      data-bs-placement="top"
      data-bs-trigger="focus"
      data-bs-content={text}>
      <i className="material-icons" aria-hidden="true">info</i>
    </button>
  );
};

InfoTooltip.propTypes = {
  text: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};

export default InfoTooltip;
